import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
  Button,
  PencilIcon,
  PlusCircleIcon,
  Separator,
  Typography,
} from '@blade/ui-kit'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { referralCodeAtom } from '@root/entities/referral'
import { ReferralCodeInline } from '@root/entities/referral/ui/referral-code-inline'
import {
  openChangeReferralCodeDialogAction,
  openCreateReferralCodeDialogAction,
} from '@root/features/referral/atoms'
import {
  ReferralCardInvite,
  ReferralCardWithdraw,
  ReferralCardInviteCode,
  ReferralCardReferrals,
} from '@root/features/referral/ui/common'
import { ReferralListDrawer } from '@root/widgets/referral'

export const ProfileReferral = () => {
  const { t } = useTranslation()
  const [referralListOpen, setReferralListOpen] = useState(false)

  const [network] = useAtom(selectedNetworkAtom)
  const [referralCode] = useAtom(referralCodeAtom)
  const openCreateReferralCodeDialog = useAction(
    openCreateReferralCodeDialogAction,
  )
  const openChangeReferralCodeDrawer = useAction(
    openChangeReferralCodeDialogAction,
  )

  const renderFooter = () => {
    if (!referralCode) {
      return (
        <Button
          size="m"
          radius="rounded"
          variant="solid"
          color="primary"
          iconLeft={<PlusCircleIcon size={20} />}
          onClick={() => openCreateReferralCodeDialog()}
        >
          {t('referral.add-referral-code')}
        </Button>
      )
    }
    return (
      <CodeInfo>
        <Separator />

        <Label>
          {t('referral.network-referral-code', {
            network: Network.label(network),
          })}
          <ReferralCodeInline network={network} code={referralCode} />
        </Label>

        <Button
          radius="rounded"
          size="m"
          variant="soft"
          iconLeft={<PencilIcon size={24} />}
          onClick={() => openChangeReferralCodeDrawer()}
        >
          {t('referral.change-referral-code')}
        </Button>
      </CodeInfo>
    )
  }

  return (
    <Root>
      <ReferralCardInvite />
      <ReferralCardReferrals
        onNavigateToReferrals={() => setReferralListOpen(true)}
      />
      <ReferralCardInviteCode />
      <ReferralCardWithdraw />
      <ReferralListDrawer
        open={referralListOpen}
        onOpenChange={setReferralListOpen}
      />
      <Footer>{renderFooter()}</Footer>
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 12px;
  padding-block: 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Label = styled(Typography).attrs({
  variant: 'body5-medium',
  component: 'div',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  color: var(--text-9);
  text-align: center;
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
`

const CodeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
